<template>
  <div>
  <b-card-actions action-collapse title="guide line ports list">
     <b-row> 
      <b-col md="12">
  
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearchPorts"
            />
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="portsColumns"
      :rows="portsRows"
      :group-options="{
        enabled: true,
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchPorts,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength2,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>


              <b-dropdown-item @click="deletePorts(props)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
                  <!-- <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/booking/edit?users=${props.row._id}`">Edit booking</router-link></span>
              </b-dropdown-item>
               -->
            </b-dropdown>
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength2"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength2"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>

  <b-card-actions action-collapse title="guide line classes list">
     <b-row> 
      <b-col md="12">
  
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearchClasses"
            />
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="classesColumns"
      :rows="classesRows"
      :search-options="{
        enabled: true,
        externalQuery: searchClasses,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>


              <b-dropdown-item @click="deleteClasses(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
                  <!-- <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/booking/edit?users=${props.row._id}`">Edit booking</router-link></span>
              </b-dropdown-item>
               -->
            </b-dropdown>
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>

  <!-- <b-card-actions action-collapse title="guide line uns list">
     <b-row> 
      <b-col md="12">
  
    <div class="custom-search">
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearchUns"
            />
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <vue-good-table
      ref="table-client"
      :columns="unsColumns"
      :rows="unsRows"
      :search-options="{
        enabled: true,
        externalQuery: searchUns,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>


              <b-dropdown-item @click="deleteUns(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
             
            </b-dropdown>
          </span>
        </span>
      </template>

      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions> -->

  <b-card-actions action-collapse title="guide line containers list">
     <b-row> 
      <b-col md="12">
  
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearchContainers"
            />
            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="containersColumns"
      :rows="containersRows"
      :search-options="{
        enabled: true,
        externalQuery: searchContainers,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>


              <b-dropdown-item @click="deleteContainers(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
                  <!-- <b-dropdown-item>
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/booking/edit?users=${props.row._id}`">Edit booking</router-link></span>
              </b-dropdown-item>
               -->
            </b-dropdown>
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</div>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import moment from 'moment';

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      pageLength: 5,
      pageLength2: 5,
      dir: false,
      portsColumns: [
        {
          label: "Action",
          field: "action",
        },
        {
          label: "Depart",
          field: "departurePort.title",
          filterOptions: {
            enabled: true,
            placeholder: "Depart",
          },
        },
        {
          label: "Arrival",
          field: "arrivalPort.title",
          filterOptions: {
            enabled: true,
            placeholder: "Arrival",
          },
        },
          {
          label: "Price",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "Price",
          },
        }
      ],
      classesColumns: [
        {
          label: "Action",
          field: "action",
        },
        {
          label: "Classe",
          field: "title",
          filterOptions: {
            enabled: true,
            placeholder: "Classe",
          },
        },
          {
          label: "Price (TND)",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "Price",
          },
        }
      ],
      unsColumns: [
        {
          label: "Action",
          field: "action",
        },
        {
          label: "Un",
          field: "title",
          filterOptions: {
            enabled: true,
            placeholder: "Un",
          },
        },
          {
          label: "Price (TND)",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "Price",
          },
        }
      ],
      containersColumns: [
        {
          label: "Action",
          field: "action",
        },
        {
          label: "Container",
          field: "title",
          filterOptions: {
            enabled: true,
            placeholder: "Un",
          },
        },
        {
          label: "Price (TND)",
          field: "price",
          filterOptions: {
            enabled: true,
            placeholder: "Price",
          },
        },
        {
          label: "Max Price (TND)",
          field: "priceMax",
          filterOptions: {
            enabled: true,
            placeholder: "Max Price",
          },
        },
        {
          label: "Weight (KG)",
          field: "weight",
          filterOptions: {
            enabled: true,
            placeholder: "Weight",
          },
        }
      ],
      portsRows: [],
      classesRows: [],
      unsRows: [],
      containersRows: [],
      searchPorts: "",
      searchClasses: "",
      searchUns: "",
      searchContainers: "",
      nameState: null,
    };
  },
  async created() {
    await this.getAllDataPorts();
    await this.getAllDataClasses();
    await this.getAllDataUns();
    await this.getAllDataContainers();
  },
  computed: {
  },
  methods: {
    getPorts(item) {
      item.ports.forEach((element) => {
        element.id = item._id;    
      })
      return item.ports
    },
    async getAllDataPorts() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/guidelines");
      response.data.data.forEach((element) => {
        this.portsRows.push({
          mode: 'span',
          label: moment(element.startDate).format('MM/DD/YYYY')+"  --------->  "+moment(element.endDate).format('MM/DD/YYYY'),
          html: false,
          children : this.getPorts(element)
        })
      })
    },   
    async getAllDataClasses() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/classes");
      this.classesRows = response.data.data;     
    },
    async getAllDataUns() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/uns");
      this.unsRows = response.data.data;     
    },
    async getAllDataContainers() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/containers");
      this.containersRows = response.data.data;     
    },
    deletePorts(id) {
      console.log(id)
      this.$swal({
        title: "you really want to delete this guide line ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/guidelines/${id}`)
            .then((response) => {
              this.getAllDataPorts();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Guide line deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    deleteClasses(id) {
      this.$swal({
        title: "you really want to delete this guide line ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/classes/${id}`)
            .then((response) => {
              this.getAllDataClasses();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Guide line deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    deleteUns(id) {
      this.$swal({
        title: "you really want to delete this guide line ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/uns/${id}`)
            .then((response) => {
              this.getAllDataUns();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Guide line deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    deleteContainers(id) {
      this.$swal({
        title: "you really want to delete this guide line ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`https://mtl-feeder-nodejs.onrender.com/api/containers/${id}`)
            .then((response) => {
              this.getAllDataContainers();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Guide line deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during deleting`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    advanceSearchPorts(val) {
      this.searchPorts = val;
    },
    advanceSearchClasses(val) {
      this.searchClasses = val;
    },
    advanceSearchUns(val) {
      this.searchUns = val;
    },
    advanceSearchContainers(val) {
      this.searchContainers = val;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}

.btn-delete-all {
  margin-left: 3%;
}
table.vgt-table td {
  vertical-align: middle !important;
}
table.vgt-table td:nth-child(1) {
  text-align: center !important;
}
.vgt-table.bordered th.vgt-row-header {
  text-align: center !important;
}
</style>
